<template>
  <div>
    <div class="right-item-content">
      <div class="right-item-view" v-for="(item,index) in questions" :key="item.id" @click="handleClick(item)">
        <div>{{index+1 +':'+ item.title}}</div>
        <img src="@/assets/image/jinru.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  data() {
    return {
      questions: []
    }
  },
  methods: {
    handleClick(item) {
      item.type = "常见问题"
      this.$router.push({
        path: '/newsdetail',
        query: {
          news: item
        }
      })
    },
       // 常见问题
       questionList() {
      http.get("/article/question/list",{pageSize:3,pageNum:1}).then((response) => {
        if (response.code === 200) {
          this.questions = response.rows;
          console.log(response);

        }
      })
    },
  },
  mounted() {
    this.questionList()
  }
};
</script>

<style lang="less" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  .right-item-view {
    height: 70px;
    border-bottom: 2px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #000000e0
  }
}
</style>
